// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7de1a4fe","251":"5ebc812e","313":"f3a69b32","361":"598a3d20","453":"19f12b3a","602":"b0c5bc7d","616":"81341ab6","814":"03fba7a2","896":"8ab4a5b2","981":"a9ec1030"}[chunkId] + ".chunk.js";
};